module.exports = {"attributes":{"width":"13","height":"14","viewBox":"0 0 13 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.15024 4.71274C2.30889 4.55409 2.56611 4.55409 2.72476 4.71274L6.5 8.48798L10.2752 4.71274C10.4339 4.55409 10.6911 4.55409 10.8498 4.71274C11.0084 4.87139 11.0084 5.12861 10.8498 5.28726L6.78726 9.34976C6.62861 9.50841 6.37139 9.50841 6.21274 9.34976L2.15024 5.28726C1.99159 5.12861 1.99159 4.87139 2.15024 4.71274Z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/down.svg
// module id = 1404
// module chunks = 0